jQuery(document).ready(function ($) {
  $(".btn1").on("click", function () {
    $(this).toggleClass("active");
    $(".menu-container").toggleClass("active");
  });

  $(".main-navigation .menu-item-has-children > a").each(function () {
    if ($(this).find(".sp-plus-icon").length === 0) {
      $(this).append('<span class="sp-plus-icon"></span>');
    }
  });

  $(".main-navigation .menu-item-has-children > a").on("click", function (e) {
    e.preventDefault();

    if (window.innerWidth < 768) {
      $(this).next("ul").slideToggle(300);
      $(this).parent("li").toggleClass("is-open");
    }
  });
});

jQuery(document).ready(function ($) {
  var $tabs = $(".about-sec3__tab-btn");
  var $rows = $(".about-sec3__row");

  var initialEra = $tabs.filter(".is-active").data("target") || "era1";
  $rows.each(function () {
    if ($(this).data("era") === initialEra) {
      $(this).css("display", "grid").addClass("is-active");
    } else {
      $(this).css("display", "none");
    }
  });

  $tabs.on("click", function () {
    var targetEra = $(this).data("target");

    $tabs.removeClass("is-active");
    $(this).addClass("is-active");

    $rows.each(function () {
      if ($(this).data("era") === targetEra) {
        $(this).css("display", "grid");
        var $self = $(this);
        setTimeout(function () {
          $self.addClass("is-active");
        }, 1);
      } else {
        $(this).css("display", "none").removeClass("is-active");
      }
    });
  });
});

jQuery(document).ready(function ($) {
  var $filterInputs = $(".top-const .tag-box input[name='paint-tag']");
  var $filterLabels = $(".top-const .tag-box label");
  var $cards = $(".top-const .const-card-box .const-card");

  if (!$filterInputs.length || !$cards.length) {
    return;
  }

  var applyTopWorksFilter = function (selectedTerm) {
    var targetTerm = String(selectedTerm || "all");

    $cards.each(function () {
      var terms = String($(this).attr("data-work-top-terms") || "");
      var topTermIds = terms
        ? terms
            .split(",")
            .map(function (id) {
              return id.trim();
            })
            .filter(Boolean)
        : [];
      var shouldShow =
        targetTerm === "all" || topTermIds.indexOf(targetTerm) !== -1;

      $(this).css("display", shouldShow ? "" : "none");
    });
  };

  $filterInputs.on("change", function () {
    applyTopWorksFilter($(this).attr("data-filter-term"));
  });

  $filterLabels.on("click", function () {
    var targetId = $(this).attr("for");
    var $targetInput = targetId ? $("#" + targetId) : $();

    if ($targetInput.length) {
      $targetInput.prop("checked", true).trigger("change");
    }
  });

  $filterInputs.filter(":checked").trigger("change");
});

jQuery(document).ready(function ($) {
  var openClass = "is-open";
  var bodyOpenClass = "is-modal-open";

  var initializeWorksModalSlider = function ($modal) {
    if (!$modal || !$modal.length || typeof Swiper === "undefined") {
      return;
    }

    $modal.find(".js-works-modal-swiper").each(function () {
      var sliderElement = this;
      var sliderInstance = sliderElement.__worksModalSwiper;

      if (sliderInstance) {
        sliderInstance.update();
        return;
      }

      sliderElement.__worksModalSwiper = new Swiper(sliderElement, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 450,
        loop: false,
        autoHeight: true,
        navigation: {
          nextEl: $(sliderElement)
            .find(".works-modal-swiper__button--next")
            .get(0),
          prevEl: $(sliderElement)
            .find(".works-modal-swiper__button--prev")
            .get(0),
        },
        pagination: {
          el: $(sliderElement).find(".works-modal-swiper__pagination").get(0),
          clickable: true,
        },
        keyboard: {
          enabled: true,
        },
      });
    });
  };

  var closeModal = function ($modal) {
    if (!$modal || !$modal.length) {
      return;
    }

    $modal.removeClass(openClass).attr("aria-hidden", "true");
    $("body").removeClass(bodyOpenClass);
  };

  var openModal = function ($modal) {
    if (!$modal || !$modal.length) {
      return;
    }

    $modal.addClass(openClass).attr("aria-hidden", "false");
    $("body").addClass(bodyOpenClass);
    initializeWorksModalSlider($modal);
  };

  $(document).on("click", "[data-modal-target]", function (e) {
    e.preventDefault();

    var modalId = $(this).attr("data-modal-target");
    var $targetModal = modalId ? $("[data-modal='" + modalId + "']") : $();

    openModal($targetModal);
  });

  $(document).on("click", "[data-modal-close]", function (e) {
    e.preventDefault();
    closeModal($(this).closest("[data-modal]"));
  });

  $(document).on("click", "[data-modal]", function (e) {
    if (
      $(e.target).is("[data-modal]") ||
      $(e.target).is("[data-modal-overlay]")
    ) {
      closeModal($(this));
    }
  });

  $(document).on("keydown", function (e) {
    if (e.key !== "Escape") {
      return;
    }

    closeModal($("[data-modal]." + openClass));
  });
});

jQuery(document).ready(function ($) {
  $(".qa__row").on("click", function () {
    $(this).next().slideToggle();
  });
});
